export const TRAINING_TYPES = {
  1: "Персональні",
  2: "Групові",
  3: "Зал",
  4: "Масажі",
};
